module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio73-64b390854aeaa351c48527cd04a08125.m4a";